/* eslint-disable */
import React from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import CircleIcon from '@mui/icons-material/Circle';

const useStyles = makeStyles(() => ({
    fontSize: {
        fontSize: 20,
    },
    wrapper: {
        position: 'relative',
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
    },
    icon: {
        fontSize: '1.5em',
    },
    count: {
        position: 'absolute',
        color: '#fff',
        fontWeight: 500,
        fontSize: '0.65em',
    },
}));
const UserCount = (props) => {
    const { filterRowsData } = props;
    const classes = useStyles();
 
    return (


        <Box className={classes.wrapper} style={{ fontSize: 16, verticalAlign:'middle' }}>
            <CircleIcon
                className={classes.icon}
                style={{ color: 'green' }}
            />
            <Typography component="span" className={classes.count}>
                {filterRowsData.length}
            </Typography>
        </Box>

    );
};

export default UserCount;
